import axiosInstance from "./axiosInstance";

const clientService = {
  fetchAllUsers: async (page, search = null) => {
    try {
      const url = search
        ? `admin/users/all/${page}?search=${encodeURIComponent(search)}`
        : `admin/users/all/${page}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  fetchCompletedUsers: async (page, search = null) => {
    try {
      const url = search
        ? `admin/users/completed/${page}?search=${encodeURIComponent(search)}`
        : `admin/users/completed/${page}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  fetchAllPremiumUsers: async (page) => {
    try {
      const response = await axiosInstance.get("admin/users/premium/" + page);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  detailsUser: async (id) => {
    try {
      const response = await axiosInstance.get("admin/users/details/" + id);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  getFilteredUsersAdmin: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "admin/users/filteredUsers",
        payload
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  fetchUserByEmail: async (identifier) => {
    try {
      // identifier can be either email or phone number
      const response = await axiosInstance.get(
        "admin/users/fetchUserByEmail/" + identifier
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  sendNotificationToFilteredUser: async (senderUserId, receiverUserId) => {
    try {
      const response = await axiosInstance.post(
        `admin/users/sendNotification/${senderUserId}/${receiverUserId}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default clientService;
